import React, { Fragment } from 'react';

import { I18n } from 'components/translate';
import { UserPhoto } from 'components/user';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';

import NotificationItemContent from './NotificationItemContent';
import NotificationItemNames from './NotificationItemNames';
import NotificationItemStandard from './NotificationItemStandard';

export default class NotificationItemInteraction extends NotificationItemStandard {
  static propTypes = {
    createDate: PropTypes.number,
    event: PropTypes.string,
    names: MobxPropTypes.observableArray,
    pageHash: PropTypes.string,
    referenceHash: PropTypes.string,
    picture: PropTypes.string,
    read: PropTypes.bool
  };

  get renderImg() {
    const { picture, names } = this.props;

    return <UserPhoto photo={picture} name={names[0]} />;
  }

  get renderContent() {
    const { names, event, createDate } = this.props;

    const isPlural = names.length > 1;
    const eventName = event.toLowerCase();
    const eventLabel = `${isPlural ? 'plural' : 'single'}.${eventName}`;

    const action = <I18n label={`notification.actions.${eventLabel}`} />;
    const location = <I18n label={`notification.locations.${eventName}`} />;

    const text = (
      <Fragment>
        <NotificationItemNames names={names} /> {action} {location}
      </Fragment>
    );

    return <NotificationItemContent text={text} date={createDate} />;
  }
}
